import React, { memo, useState } from 'react';

import { Button } from '@components/common';
import RadioButton from '@components/common/Form/RadioButton';

import { IExportDefaultDTO } from '@interfaces/common/defaultDTO';
import { IExportRadioButtons } from '@components/common/FileTypeSelectionForm/FileTypeSelectionForm.types';

import { EExportFileTypes, EMenuActionsTypes, TExportFileTypes, TMenuActionsTypes } from '@enums/common';

import styles from './FileTypeSelectionForm.module.scss';

export type THandleExport = (data: IExportDefaultDTO) => void;

export interface IFileTypeSelectionFormParams {
	activeGroupTableAction?: TMenuActionsTypes;
	closeModals: () => void;
	handlePreparingExport: THandleExport;
	exportData?: any;
	isLoading: boolean;
	selectedIds?: Array<any> | null;
	toggleModal: () => void;
	filter?: Record<string, any>;
	exportRadioButtonsData: Array<IExportRadioButtons>;
}

const FileTypeSelectionForm = ({
	activeGroupTableAction,
	closeModals,
	handlePreparingExport,
	isLoading,
	selectedIds = null,
	toggleModal,
	filter,
	exportRadioButtonsData,
}: IFileTypeSelectionFormParams) => {
	const [activeRadioButton, setActiveRadioButton] = useState<TExportFileTypes>(EExportFileTypes.csv);

	const onSubmit = () => {
		handlePreparingExport({
			fileType: activeRadioButton,
			ids: selectedIds,
			filter: activeGroupTableAction === EMenuActionsTypes.allFiltered && filter
				? filter
				: null,
			isAll: activeGroupTableAction === EMenuActionsTypes.all
				|| activeGroupTableAction === EMenuActionsTypes.allFiltered,
		});

		closeModals();
	};

	return (
		<div>
			<div className={styles.buttonGroup}>
				{
					exportRadioButtonsData.map((btn) => {
						const onChange = (id: TExportFileTypes) => {
							setActiveRadioButton(id);
						};

						return (
							<div
								key={`${btn.name}-parent`}
								className={styles.radioBtnContainer}
							>
								<RadioButton
									key={btn.name}
									checked={activeRadioButton === btn.name}
									disabled={btn.disabled || isLoading}
									id={btn.name}
									label={btn.label}
									name={btn.name}
									onChange={onChange}
								/>
							</div>
						);
					})
				}
			</div>
			<div className={styles.submitButtons}>
				<Button
					onClick={toggleModal}
					text='Cancel'
					withoutBackground
				/>
				<Button
					disabled={!activeRadioButton || isLoading}
					onClick={onSubmit}
					text='Export'
				/>
			</div>
		</div>
	);
};

export default memo(FileTypeSelectionForm);
